import manifest from '@/access_manifest.json';

export const roleLabel = (name) => Object.values(manifest.roles)
  .find((role) => role.name === name)?.label ?? name;

export const transitionKey = (entity, from, to) => `transition.${entity}.${Number(from)}.${Number(to)}`;

export const hasTransitionAccess = (user, entity, from, to) => user.roles?.some(({ name }) => name === 'owner')
  || user.permissions?.includes(transitionKey(entity, from, to)) === true;
